import { render, staticRenderFns } from "./ArchivedChallengeList.vue?vue&type=template&id=74581c6c&"
import script from "./ArchivedChallengeList.vue?vue&type=script&lang=js&"
export * from "./ArchivedChallengeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports